module.exports = __webpack_public_path__ + "img/Slice 268@2x(3).5ed9b37b.png";